
/* styles */
require("!!vue-style-loader!css-loader!../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-dd6b0624\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader!../node_modules/vue-loader/lib/selector?type=styles&index=0!./Home.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./Home.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-dd6b0624\"}!../node_modules/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!../node_modules/vue-loader/lib/selector?type=template&index=0!./Home.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/Home.vue
// module id = 193
// module chunks = 0